import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .444444,
			y: .444444,
			width: 31.1111,
			height: 31.1111,
			rx: 15.5556,
			fill: "url(#paint0_linear_3769_189814)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .444444,
			y: .444444,
			width: 31.1111,
			height: 31.1111,
			rx: 15.5556,
			stroke: "#ECECEC",
			strokeWidth: .888889
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9983 24.4266C15.9983 23.4682 15.8209 22.5675 15.466 21.7246C15.1222 20.8817 14.6508 20.1484 14.0519 19.5249C13.453 18.9014 12.7487 18.4106 11.939 18.0527C11.1294 17.6832 10.2643 17.4984 9.34375 17.4984C10.2643 17.4984 11.1294 17.3194 11.939 16.9615C12.7487 16.592 13.453 16.0955 14.0519 15.472C14.6508 14.8484 15.1222 14.1152 15.466 13.2723C15.8209 12.4294 15.9983 11.5287 15.9983 10.5703C15.9983 11.5287 16.1703 12.4294 16.5141 13.2723C16.869 14.1152 17.3459 14.8484 17.9448 15.472C18.5437 16.0955 19.248 16.592 20.0576 16.9615C20.8673 17.3194 21.7324 17.4984 22.6529 17.4984C21.7324 17.4984 20.8673 17.6832 20.0576 18.0527C19.248 18.4106 18.5437 18.9014 17.9448 19.5249C17.3459 20.1484 16.869 20.8817 16.5141 21.7246C16.1703 22.5675 15.9983 23.4682 15.9983 24.4266Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4984 12.4733C10.4984 12.1314 10.4352 11.8102 10.3086 11.5096C10.1859 11.2089 10.0178 10.9474 9.80421 10.725C9.5906 10.5026 9.33941 10.3276 9.05064 10.1999C8.76188 10.0681 8.45333 10.0023 8.125 10.0023C8.45333 10.0023 8.76188 9.93842 9.05064 9.81076C9.33941 9.67896 9.5906 9.50188 9.80421 9.27949C10.0178 9.0571 10.1859 8.79558 10.3086 8.49494C10.4352 8.1943 10.4984 7.87307 10.4984 7.53125C10.4984 7.87307 10.5598 8.1943 10.6824 8.49494C10.809 8.79558 10.9791 9.0571 11.1927 9.27949C11.4063 9.50188 11.6575 9.67896 11.9463 9.81076C12.235 9.93842 12.5436 10.0023 12.8719 10.0023C12.5436 10.0023 12.235 10.0681 11.9463 10.1999C11.6575 10.3276 11.4063 10.5026 11.1927 10.725C10.9791 10.9474 10.809 11.2089 10.6824 11.5096C10.5598 11.8102 10.4984 12.1314 10.4984 12.4733Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_3769_189814)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M21.5014 15.6836C21.5014 15.3121 21.4326 14.9629 21.295 14.6362C21.1617 14.3095 20.979 14.0253 20.7469 13.7836C20.5147 13.5419 20.2417 13.3516 19.9279 13.2129C19.614 13.0696 19.2787 12.998 18.9219 12.998C19.2787 12.998 19.614 12.9287 19.9279 12.7899C20.2417 12.6467 20.5147 12.4542 20.7469 12.2125C20.979 11.9708 21.1617 11.6866 21.295 11.3599C21.4326 11.0331 21.5014 10.684 21.5014 10.3125C21.5014 10.684 21.568 11.0331 21.7013 11.3599C21.8389 11.6866 22.0237 11.9708 22.2559 12.2125C22.488 12.4542 22.761 12.6467 23.0749 12.7899C23.3887 12.9287 23.724 12.998 24.0809 12.998C23.724 12.998 23.3887 13.0696 23.0749 13.2129C22.761 13.3516 22.488 13.5419 22.2559 13.7836C22.0237 14.0253 21.8389 14.3095 21.7013 14.6362C21.568 14.9629 21.5014 15.3121 21.5014 15.6836Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_3769_189814",
			x1: -8.36981,
			y1: 16.0007,
			x2: 36.9018,
			y2: 16.0007,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#003399" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#06D0DB"
			})]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3769_189814",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 6,
				height: 6,
				fill: "white",
				transform: "translate(18.5 10)"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgAvatar);
export { ForwardRef as ReactComponent };
